import Icon from "../../common/components/Icon";
import Tooltip from "../../theme/components/Tooltip";
import useMigelConformity from "../hooks/useMigelConformity";

const MigelConformity = ({ migelConformity, className = "" }) => {
  const [icon, title, description] = useMigelConformity(migelConformity);

  return (
    <div
      className={`d-flex align-items-center ${className || ""}`}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onTouchStart={(e) => {
        e.stopPropagation();
      }}
    >
      {icon && (
        <Tooltip
          showIconInTooltipMessage
          title={title}
          description={description}
        >
          <Icon icon={icon} className="icon--mdl" />
        </Tooltip>
      )}
    </div>
  );
};

export default MigelConformity;
